module.exports = __webpack_public_path__ + "static/media/29ADMSPC10.22969719.jpg";